<h4 class="mb-0 pb-1 mt-2 mt-lg-1">{{ multiplePossibilitiesLabel }}</h4>
<div class="d-flex flex-column flex-lg-row">
  @for (entryPoint of entryPoints; track entryPoint) {
    <div
      class="col border-left border-gray4 seo-exit-block pl-0 pb-3 pb-lg-0 pr-lg-3 pl-lg-4 d-flex flex-column justify-content-between"
      >
      @if (!entryPoint.h4) {
        <p><strong>{{ entryPoint.title }}</strong></p>
      }
      @if (entryPoint.h4) {
        <h4 class="mb-1">{{ entryPoint.title }}</h4>
      }
      <p class="h-100">{{ entryPoint.description }}</p>
      <p class="text-center text-md-left mb-0 pb-0">
        <a
          href=""
          class="btn btn-primary"
          (click)="emitLoginEvent(entryPoint);false"
          [attr.data-e2e]="e2e + '-login-' + entryPoint.id"
          >
          {{ entryPoint.confirmationLabel }}
        </a>
      </p>
    </div>
  }
</div>
